export const getSelectedLanguage = state => state.LanguageReducer.language;
